import { StoreProductsSectionProps } from './store-products-section.types'
// import styles from './store-products-section.module.scss'
// import cl from 'classnames'
import { H2, SectionContainer, NoneLabel, Button } from '@touche-lts/panel-ui/dist'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { ProductsTable } from 'components'

const StoreProductsSectionComponent = (props: StoreProductsSectionProps) => {
  const { ...sectionContainerProps } = props
  const {
    storeProductsTableStore: {
      triggerSearch,
      catalogElementsTotalCount,
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      searchResults,
      paginationInfo,
      onPageSelect,
      clearStore,
      storeId,
      handleSyncProducts,
    }
    ,
    viewStorePageStore : {
store
    }
  } = useRootStore()

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
    return clearStore
  }, [triggerSearch, clearStore, storeId])

  const hasProducts = catalogElementsTotalCount > 0

  return (
    <SectionContainer {...sectionContainerProps}>
      <div style={{display:'flex',justifyContent : "space-between",alignItems : "center",flexDirection : "row"}}>
      <H2>Products {hasProducts && `(${catalogElementsTotalCount})`}</H2>
       {
        store?.shopifyAccessToken && store?.shopifyStoreUrl && 
        <Button
          preset='primary'
          style={{ width: 250}}
          onClick={async()=>{
           await handleSyncProducts()
          }}
          >
          Sync Products From Shopify Store
        </Button>
      }
      </div>
      {!hasProducts ? (
        <NoneLabel label='No products yet.' />
      ) : (
        <ProductsTable
          containerProps={{
            noBoxShadow: true,
            style: { marginTop: 15, minHeight: 230 }
          }}
          hideStoreColumn
          isColumnMarked={isColumnMarked}
          getSortDirection={getSortDirection}
          handleSortDirectionChange={handleSortDirectionChange}
          searchProps={searchProps}
          onSearchPropsChange={onSearchPropsChange}
          searchResults={searchResults}
          paginationInfo={paginationInfo}
          onPageSelect={onPageSelect}
        />
      )}
    </SectionContainer>
  )
}

const StoreProductsSection = observer(StoreProductsSectionComponent)
export { StoreProductsSection }
